// Rails renders the HTML; Vue takes the ERB output inside #app and compiles it
// as its own template. That means component tags can be written directly in any
// .html.erb file:
//
//   <Home phone="56912345678"></Home>
//
// Every .vue file under pages/ and components/ is registered globally, so there
// is nothing to import on the Rails side. The in-DOM template rules (close your
// tags, kebab-case props) are documented in app/frontend/README.md.

import '@/styles/application.css'

import { createApp } from 'vue'
import registerComponents from '@/registry'

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('app')
  if (!root) return

  const app = createApp({})
  registerComponents(app)
  app.mount(root)
  root.removeAttribute('v-cloak')
})
